import React, { useEffect } from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import power from '../Pages/Newimages/empowering.png'
import AOS from 'aos';

const Newcontact = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });
    }, []);
    return (
        <div>
            <Newnavbar />
            <div className="contact_banner_all">
                <div className="new_about_ban_des container mx-auto">
                    <h2>Get in Touch with PayNeft  We’re Here to Help!</h2>
                    <p>Have a question or need assistance? Our team is ready to help you with anything you need. Whether you’re looking for support or want to know more about PayNeft’s features, reach out to us anytime. We’re just a message away</p>
                </div>
            </div>
            <section className='bg-[#fff1f6]'>
            <div className=" new_get_in_touch my-5 max-w-7xl mx-auto ">
                <div className="flex flex-col md:flex-row items-center mx-auto">
                    <div className=" new_con_form md:w-6/12 w-12/12 md:!p-[80px] !p-[16px]">
                        <h1>Get in touch with us</h1>
                        <p>Drop your email and Connect with us, and we’ll help bring your ideas to life!</p>
                        <form>
                            <div className="form-group ">
                                <input
                                    type="text"
                                    className="form-control w-full !bg-gray-200"
                                    id="email"
                                    placeholder="Enter your Mail"
                                />
                            </div>
                            <div className="form-group ">
                                <input
                                    type="email"
                                    className="form-control w-full !bg-gray-200"
                                    id="name"
                                    placeholder="Enter your Name"
                                />
                            </div>
                            <button type="submit" >Submit</button>
                        </form>
                    </div>

                    <div className="md:w-6/12 w-12/12 md:!p-[80px] !p-[16px]">
                        <img src={power} alt="Edge" className="img-fluid"  data-aos="zoom-in-up"  />

                    </div>

                </div>
            </div>
            </section>
            <Newfooter />

        </div>
    )
}

export default Newcontact
